import { getOWAConnectedAccount } from 'owa-accounts-store';

export function getOWAConnectedAccountUniqueId(primarySmtpAddress: string): string {
    const connectedAccount = getOWAConnectedAccount(primarySmtpAddress);
    if (connectedAccount) {
        return connectedAccount.accountUniqueId;
    } else {
        return '-1';
    }
}
